// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-page__spinner{width:100%;height:50vh;display:flex;align-items:center;justify-content:center}.new-page__content{width:100%}@media(max-width:1049px){.new-page__content{padding:0 15px!important;margin-inline-end:0;margin-inline-start:0}}", ""]);
// Exports
module.exports = exports;
